import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    gap: 20px;

    overflow-y: scroll;
    height: 470px;

    &::-webkit-scrollbar { 
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_200};
        border-radius: 20px;
    }
`;

export const InforHead = styled.div`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    color: ${(props) => props.theme.colors.blue};

    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
    span{
        font-weight: 500;
        margin-right: 4px;
    }
`;

export const SeparateDiv = styled.div`
    display: flex;
    gap: 20px;
`;

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    input[type='text']{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const TextArea = styled.textarea`
    border: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    border-radius: 4px;
    resize: none;

    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const ModalCalculate = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    gap: 20px;
`;

export const HeadCalc = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0px;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};

    p{
        font-weight: 500;
    }
`;

export const ButtonAction = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.primary_low};
    
    padding: 8px 10px;
    border-radius: 4px;
    
    &:hover{
        font-weight: 500;
    }
`;

export const FormsSection = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    gap: 20px;

    .highlight{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const HeaderSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0px;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};

    font-weight: 500;

    p{
        display: flex;
        align-items: center;
        gap: 4px;

        svg{
            color: ${(props) => props.theme.colors.primary};
        }
    }
`;